module.exports = __webpack_public_path__ + "static/media/10UNOHRLLS11.9cc6fc96.jpg";